import { isNumeric } from '../../../../js/app/react/validators';

const shouldSkip = (isGoingForward, hasPartner, yearlySalary, partnerYearlySalary) =>
  isGoingForward && isNumeric(yearlySalary) && (!hasPartner || isNumeric(partnerYearlySalary));

export default shouldSkip;
